import styled from "styled-components";
import solasColors from "@boi/design-tokens/dist/web/boi/light/tokens.json";
import { remCalc } from "./style-utils-coras-nua";
import { space, typography, color, layout } from "styled-system";
import defaultTheme from "./theme-test-override";
import { ThemeProps, ThemeTemplate } from "./theme-template";

type HeadingProps = {
    mb?: number | Array<number> | string;
    mt?: number | Array<number> | string;
    fontSize?: number | Array<number> | string;
    lineHeight?: number | Array<number> | string;
    fontWeight?: string;
    color?: string;
    width?: string;
    textAlign?: string;
} & ThemeProps;

const Heading = styled("h1")<HeadingProps>`
    ${space}
    ${color}
    ${layout}
    ${typography}
    &.title-decorator{
        margin-bottom: ${props => props.theme.space[4]};
        &:after{
            background-color: ${props => props.theme.colors.primary};
            content: "";
            display: block;
            height: 0.25rem;
            margin-top: 0.5rem;
            width: 1.5rem;
        }
    }
`;

Heading.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate,
    mb: 10,
    mt: 0,
    fontSize: 5,
    lineHeight: 7,
    fontWeight: "bold",
    color: "monotoneDark",
    textAlign: "center"
};

const PcaHeading = styled(Heading)`
    ${color}
    ${layout}
    ${typography}
`;
PcaHeading.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate,
    color: "monotoneDark"
};

const PcaSubHeading = styled("h2")<HeadingProps>`
    ${space}
    ${typography}
    ${layout}
    ${color}
    &.title-decorator{
        margin-bottom: ${props => props.theme.space[4]};
        &:after{
            background-color: ${props => props.theme.colors.primary};
            content: "";
            display: block;
            height: 0.25rem;
            margin-top: 0.5rem;
            width: 1.5rem;
        }
    }
    strong{
        font-weight: ${props => props.theme.fontWeights.semiBold}
    }
`;
PcaSubHeading.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate,
    mb: 7,
    mt: 0,
    fontSize: 4,
    lineHeight: 6,
    color: "monotoneDark",
    fontWeight: "normal"
};

const Heading3 = styled("h3")<HeadingProps>`
    ${space}
    ${typography}
    ${color}
    ${layout}
    &.title-decorator{
        margin-bottom: ${props => props.theme.space[4]};
        &:after{
            background-color: ${props => props.theme.colors.primary};
            content: "";
            display: block;
            height: 0.25rem;
            margin-top: 0.5rem;
            width: 1.5rem;
        }
    }
 `;

Heading3.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate,
    mb: 2,
    mt: 0,
    fontSize: "18px",
    lineHeight: 6,
    fontWeight: "bold",
    color: "monotoneDark"
};

const Heading2 = styled("h2")<HeadingProps>`
    ${space}
    ${typography}
    ${color}
    ${layout}
    &.title-decorator{
        margin-bottom: ${props => props.theme.space[4]};
        &:after{
            background-color: ${props => props.theme.colors.primary};
            content: "";
            display: block;
            height: 0.25rem;
            margin-top: 0.5rem;
            width: 1.5rem;
        }
    }
 `;

Heading2.defaultProps = Heading3.defaultProps;
Heading2.defaultProps.fontSize = 5;

type ParagraphProps = {
    mb?: number | Array<number> | string;
    mt?: number | Array<number> | string;
    mr?: number | Array<number> | string;
    ml?: number | Array<number> | string;
    fontSize?: number | Array<number> | string;
    lineHeight?: number | Array<number> | string;
    fontWeight?: string;
    color?: string;
    width?: string;
} & ThemeProps;

const Paragraph = styled("p")<ParagraphProps>`
    ${space}
    ${color}
    ${typography}
    ${layout}
    small {
        font-size: ${remCalc(12)};
        line-height: ${remCalc(17)};
    }
    strong {
        font-weight: ${props => props.theme.fontWeights.semiBold};
    }
    word-break: break-word;
`;
Paragraph.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate,
    mb: 4,
    mt: 0,
    fontSize: 2,
    lineHeight: 5,
    color: "monotoneDark",
    fontWeight: "regular"
};

type ProgressStepProps = {
    mb: number | Array<number> | string;
    mt: number | Array<number> | string;
    fontSize: number | string;
    lineHeight: number | string;
    fontWeight: string;
    color: string;
};

const ProgressStep = styled("h5")<ProgressStepProps>`
    ${space}
    ${color}
    ${typography}
    color: ${solasColors.themeColor.base400};
`;

ProgressStep.defaultProps = {
    theme: {
        ...defaultTheme
    },
    mt: 2,
    mb: 3,
    fontSize: 0,
    lineHeight: 3,
    color: "monotoneMidDark",
    fontWeight: "regular"
};

export {
    Heading,
    PcaHeading,
    PcaSubHeading,
    Heading3,
    Heading2,
    Paragraph,
    ProgressStep
};
